import React from 'react';

import { Typography } from '@ag1/ui';

import CustomPortableText from 'shared/studio/PortableText/PortableText';

import { useFooterContext } from '../FooterContext';
import FooterCookieConsent from '../FooterCookieConsent/FooterCookieConsent';

import styles from './styles.module.scss';

const FooterDisclaimer = () => {
  const {
    data: { boxDisclaimer = [], disclaimer }
  } = useFooterContext();

  const typographyConfig = {
    variant: 'caption',
    size: '1',
    noPadding: true,
    component: 'div'
  } as const;

  return (
    <>
      {boxDisclaimer?.length > 0 && (
        <Typography {...typographyConfig} className={styles.boxText}>
          {boxDisclaimer.map(
            ({ portableText = [], _key }) =>
              portableText?.length > 0 && (
                <CustomPortableText key={_key} id="fdaDisclaimer" value={portableText} />
              )
          )}
        </Typography>
      )}
      <Typography {...typographyConfig} className={styles.text}>
        <CustomPortableText value={disclaimer} id="generalDisclaimer" />
      </Typography>
      <FooterCookieConsent className={styles.legal} />
    </>
  );
};

export default FooterDisclaimer;
